import TableCard from "@/components/card/TableCard";
import { useCols } from "@/utils/responsive";

export default function SectionGrid({ tables }) {
  const cols = useCols();

  if (!tables || tables.length === 0) return null;

  // CR-0012 — sizing rule: rows share a uniform height per CSS Grid
  // auto-rows rule. Floor at 135px so action bar never clips; max is
  // open so very wide cells aren't capped (no aspect-ratio fight).
  return (
    <div
      data-testid="section-grid"
      className="grid gap-2"
      style={{
        gridTemplateColumns: `repeat(${cols}, minmax(0, 1fr))`,
        gridAutoRows: "minmax(135px, auto)",
      }}
    >
      {tables.map((table) => (
        <TableCard key={table.code} table={table} />
      ))}
    </div>
  );
}
